import React from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  notification,
  DatePicker,
} from "antd";
import "dayjs/locale/es-mx";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { create } from "../../../../../controllers/store/actions/projects/create-project-action";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import SelectKnowledgeGran from "../../Elements/Select-Knowledge-Gran";
import SelectCities from "../../Elements/Select-Cities";
import SelectProjectStatus from "../../Elements/Select-Project-status";
import SelectProducts from "../../Elements/Select-Product-";
import { Capacity } from "../../../..";

interface Props {
  loading?: boolean;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewProjectModal: React.FC<Props> = (props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const createdProject = useSelector((state: any) => state.createdProject);
  const CapacitiesTypeState = useSelector(
    (state: any) => state.capacitiesTypes
  );

  return (
    <Modal
      width={800}
      visible={props.visible}
      title={"Proyecto"}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values: any) => {
              await dispatch(
                create({
                  ...values,
                  area_de_conocimiento: values.area_de_conocimiento?.value,
                  especialidad_de_conocimiento:
                    values.especialidad_de_conocimiento?.value,
                  gran_area_de_conocimiento:
                    values.gran_area_de_conocimiento?.value,
                  products: values.products?.map((e: any) => ({
                    products_id: e.value,
                  })),
                  estado_proyecto: values.estado_proyecto?.value,
                  city: values.city?.value,
                  capacity_type: CapacitiesTypeState.list.find(
                    (c: any) => c.collection_name === Capacity.Projects
                  )?.id,
                })
              );
              props.onCreated();
            });
          }}
          name="newProject"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={16}>
              <Form.Item
                label="Nombre del proyecto"
                name="titulo_proyecto"
                rules={[
                  { required: true, message: "Por favor ingrese el nombre" },
                ]}
              >
                <Input placeholder="Nombre del proyecto" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("city", selected);
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Area general"
                name="area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Área general"
                  onChange={(selected: any) => {
                    form.setFieldValue("area_de_conocimiento", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Área específica"
                name="especialidad_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  size="large"
                  defaultValue="Área específica"
                  onChange={(selected: any) => {
                    form.setFieldValue(
                      "especialidad_de_conocimiento",
                      selected
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Gran área del conocimiento"
                name="gran_area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeGran
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Gran Área de conocimiento"
                  onChange={(selected: any) => {
                    form.setFieldValue("gran_area_de_conocimiento", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Descripción detallada"
                name="descripcion_detallada"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la descripción detallada",
                  },
                ]}
              >
                <Input.TextArea placeholder="Descripción detallada" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tiempo de ejecución"
                name="tiempo_de_ejecucion_estimado"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el Tiempo estimado",
                  },
                ]}
              >
                <Input placeholder="Tiempo de ejecución" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Presupuesto"
                name="presupuesto_estimado"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el presupuesto",
                  },
                ]}
              >
                <Input placeholder="Presupuesto" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tipo de proyecto"
                name="tipo_proyecto"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el tipo de proyecto",
                  },
                ]}
              >
                <Input placeholder="Tipo de proyecto" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Aliados del proyecto"
                name="aliados_del_proyecto"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese los aliados del proyecto",
                  },
                ]}
              >
                <Input placeholder="Aliados del proyecto" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Estado actual del proyecto"
                name="estado_proyecto"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectProjectStatus
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("estado_proyecto", selected);
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Producto"
                name="products"
                rules={[{ type: "array" }]}
              >
                <SelectProducts
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  mode={"multiple"}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("products", selected);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={createdProject?.isLoading}
              type="primary"
              size="large"
              block
              htmlType="submit"
            >
              Agregar Proyecto
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default NewProjectModal;
